export default __webpack_public_path__ + "static/tour-interior-preview-btn-small-60f0946a5a302d3cb8bb2b2491664085.png";